import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function Timer3SelectIcon(props: IconProps) {
    return <Icon {...props} iconKey={"timer_3_select"}/>
}
